// Agriculture and Farming Skills organized by subcategories
export const AGRICULTURE_FARMING_SKILLS_CATEGORIES = [
  {
    name: 'Crop Management',
    skills: [
      'Crop Planning', 'Soil Preparation', 'Seeding Techniques',
      'Irrigation Management', 'Pest Control', 'Disease Management',
      'Harvest Planning', 'Yield Optimization', 'Crop Rotation',
      'Fertilizer Management', 'Weed Control', 'Growth Monitoring',
      'Quality Assessment', 'Post-harvest Handling', 'Storage Management'
    ]
  },
  {
    name: 'Livestock Management',
    skills: [
      'Animal Husbandry', 'Feed Management', 'Health Monitoring',
      'Breeding Programs', 'Disease Prevention', 'Nutrition Planning',
      'Growth Tracking', 'Welfare Standards', 'Housing Management',
      'Herd Management', 'Veterinary Care', 'Record Keeping',
      'Quality Control', 'Production Planning', 'Biosecurity'
    ]
  },
  {
    name: 'Soil Management',
    skills: [
      'Soil Testing', 'Fertility Management', 'Erosion Control',
      'Composting', 'pH Balance', 'Nutrient Management',
      'Soil Conservation', 'Organic Matter', 'Drainage Systems',
      'Soil Structure', 'Microbial Health', 'Soil Analysis',
      'Amendment Planning', 'Quality Control', 'Sustainability'
    ]
  },
  {
    name: 'Farm Operations',
    skills: [
      'Equipment Operation', 'Maintenance Planning', 'Resource Management',
      'Safety Protocols', 'Workflow Planning', 'Staff Coordination',
      'Quality Control', 'Process Improvement', 'Cost Management',
      'Risk Assessment', 'Documentation', 'Compliance Management',
      'Emergency Planning', 'Performance Monitoring', 'Innovation Planning'
    ]
  },
  {
    name: 'Sustainable Agriculture',
    skills: [
      'Organic Farming', 'Conservation Methods', 'Water Management',
      'Biodiversity', 'Renewable Energy', 'Waste Management',
      'Natural Pest Control', 'Soil Conservation', 'Resource Efficiency',
      'Environmental Impact', 'Certification Standards', 'Best Practices',
      'Innovation Methods', 'Climate Adaptation', 'Sustainability Planning'
    ]
  },
  {
    name: 'Agricultural Technology',
    skills: [
      'Precision Farming', 'GPS Systems', 'Automation Systems',
      'Data Analytics', 'Monitoring Systems', 'Smart Irrigation',
      'Drone Technology', 'Software Applications', 'Equipment Technology',
      'System Integration', 'Data Management', 'Technology Planning',
      'Innovation Adoption', 'Performance Analysis', 'Quality Control'
    ]
  },
  {
    name: 'Farm Business Management',
    skills: [
      'Financial Planning', 'Market Analysis', 'Business Strategy',
      'Risk Management', 'Budget Control', 'Record Keeping',
      'Supply Chain', 'Marketing Strategy', 'Contract Management',
      'Cost Analysis', 'Performance Metrics', 'Growth Planning',
      'Innovation Strategy', 'Quality Standards', 'Compliance Management'
    ]
  },
  {
    name: 'Food Safety',
    skills: [
      'Safety Standards', 'Quality Control', 'Hygiene Protocols',
      'Contamination Prevention', 'Storage Standards', 'Processing Standards',
      'Documentation', 'Risk Assessment', 'Compliance Management',
      'Audit Preparation', 'Training Programs', 'Emergency Procedures',
      'Best Practices', 'Quality Assurance', 'Safety Innovation'
    ]
  },
  {
    name: 'Greenhouse Management',
    skills: [
      'Climate Control', 'Irrigation Systems', 'Crop Planning',
      'Disease Management', 'Pest Control', 'Growth Monitoring',
      'Resource Management', 'Equipment Maintenance', 'Quality Control',
      'Production Planning', 'Staff Training', 'System Optimization',
      'Innovation Methods', 'Performance Analysis', 'Sustainability'
    ]
  },
  {
    name: 'Agricultural Research',
    skills: [
      'Research Methods', 'Data Collection', 'Analysis Techniques',
      'Trial Management', 'Documentation', 'Quality Control',
      'Innovation Planning', 'Performance Analysis', 'Best Practices',
      'Research Design', 'Data Management', 'Report Generation',
      'Literature Review', 'Research Tools', 'Research Planning'
    ]
  },
  {
    name: 'Organic Farming',
    skills: [
      'Organic Standards', 'Natural Methods', 'Pest Management',
      'Soil Health', 'Crop Rotation', 'Composting',
      'Certification Process', 'Quality Control', 'Documentation',
      'Market Development', 'Innovation Planning', 'Best Practices',
      'Sustainability', 'Resource Management', 'Organic Innovation'
    ]
  },
  {
    name: 'Agricultural Education',
    skills: [
      'Training Development', 'Program Management', 'Knowledge Transfer',
      'Skill Assessment', 'Documentation', 'Best Practices',
      'Innovation Methods', 'Performance Analysis', 'Quality Control',
      'Resource Planning', 'Program Evaluation', 'Content Development',
      'Teaching Methods', 'Learning Tools', 'Education Planning'
    ]
  },
  {
    name: 'Agricultural Engineering',
    skills: [
      'System Design', 'Equipment Planning', 'Infrastructure Development',
      'Resource Management', 'Innovation Planning', 'Performance Analysis',
      'Quality Control', 'Documentation', 'Best Practices',
      'Project Management', 'Cost Analysis', 'Risk Assessment',
      'System Integration', 'Technology Planning', 'Engineering Innovation'
    ]
  },
  {
    name: 'Agricultural Processing',
    skills: [
      'Processing Methods', 'Quality Control', 'Safety Standards',
      'Equipment Operation', 'Process Improvement', 'Documentation',
      'Innovation Planning', 'Performance Analysis', 'Best Practices',
      'Resource Management', 'Cost Control', 'Risk Assessment',
      'System Integration', 'Technology Planning', 'Processing Innovation'
    ]
  },
  {
    name: 'Agricultural Leadership',
    skills: [
      'Team Leadership', 'Strategic Planning', 'Resource Management',
      'Performance Management', 'Innovation Leadership', 'Quality Assurance',
      'Change Management', 'Risk Management', 'Decision Making',
      'Problem Solving', 'Staff Development', 'Success Planning',
      'Growth Strategy', 'Future Planning', 'Leadership Innovation'
    ]
  }
];

// Export flattened list for backward compatibility
export const AGRICULTURE_FARMING_SKILLS = AGRICULTURE_FARMING_SKILLS_CATEGORIES.reduce(
  (acc, category) => [...acc, ...category.skills],
  [] as string[]
);
